var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_250_2",
    "data-name": "Component 250 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_467",
    "data-name": "Ellipse 467",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "rgba(68,84,111,0.1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_93913",
    "data-name": "Path 93913",
    d: "M10.711,12.747c-.047.2-.09.383-.132.564-.013.059-.06.068-.107.081a8.361,8.361,0,0,1-1.242.442,2.164,2.164,0,0,1-1.8-.27,1.315,1.315,0,0,1-.546-1.208,13.77,13.77,0,0,1,.606-2.628A5.972,5.972,0,0,0,7.744,8.41c.009-.5-.2-.721-.683-.712a2.544,2.544,0,0,0-.879.207c.047-.207.09-.392.137-.582a.142.142,0,0,1,.094-.1,5.2,5.2,0,0,1,2.16-.514A1.45,1.45,0,0,1,9.925,7.783a2.633,2.633,0,0,1-.047,1.168c-.209.92-.521,1.812-.713,2.736a2.617,2.617,0,0,0-.064.6.521.521,0,0,0,.457.586,1.854,1.854,0,0,0,1.059-.108c.026-.009.047-.014.1-.027ZM9.494,3.091a1.037,1.037,0,0,0-.154.009A1.264,1.264,0,0,0,8.273,4.759a1.328,1.328,0,0,0,1.6.8A1.254,1.254,0,0,0,10.818,4.4,1.279,1.279,0,0,0,9.49,3.091Z",
    fill: "rgba(68,84,111,0.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.cd313512d47e2e349f6911aaf05490ac.svg";
export { ForwardRef as ReactComponent };